export const revalidateOptions = {
  revalidateIfStale: false, // https://swr.vercel.app/docs/revalidation.en-US#revalidate-on-mount
  revalidateOnFocus: true, // https://swr.vercel.app/docs/revalidation.en-US#revalidate-on-focus
  revalidateOnReconnect: true, // https://swr.vercel.app/docs/revalidation.en-US#revalidate-on-reconnect
};
